export const contentQueryKey = ["content"] as const;
